const styles = (theme) => ({
    root: {},
    inputLabel: {
        textDecoration: 'underline',
        opacity: 1.0,
        color: '#000',
    },
});

export default styles;
